import { useEffect } from "react";

// Site yalnızca aydınlık tema kullanır — karanlık mod kaldırıldı.
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.add("light");
    document.documentElement.classList.remove("dark");
    localStorage.setItem("parasyo-theme", "light");
  }, []);
  return children;
};
